module.exports = __webpack_public_path__ + "static/media/Vector.2ab26747.svg";